import { combineReducers } from '@reduxjs/toolkit'
import auth from './features/auth/authSlice'
import portlet from './features/portlet/portletSlice'
import account from './features/account/accountSlice'
import manageUsers from './features/account/manageUsersSlice'
const rootReducer = combineReducers({ auth, portlet, account, manageUsers })

export default rootReducer
